import { Navigate, useNavigate, useSearchParams } from "react-router";
import { loginReturnPath } from "@/features/auth/lib/login-return-path";
import { useAuth } from "@/features/auth/lib/use-auth";
import { StaffLoginModal } from "@/features/auth/ui/login-modal";

export function LoginPage() {
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const { isAuthenticated } = useAuth();
	const next = loginReturnPath(params.get("next"));

	if (isAuthenticated) {
		return <Navigate to={next} replace />;
	}

	const goBack = () => navigate(next, { replace: true });

	return <StaffLoginModal opened onClose={goBack} onSignedIn={goBack} />;
}
